import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiGradientCircleComponent } from './fi-gradient-circle.component';

@NgModule({
    declarations: [FiGradientCircleComponent],
    imports: [CommonModule],
    exports: [FiGradientCircleComponent],
})
export class FiGradientCircleModule {}
